import {Card, Col, Row} from "react-bootstrap";
import Container from "react-bootstrap/Container";
import API from "../api/api"
import {useEffect, useState} from "react";
import {Link} from "react-router-dom";

function Games() {
    const [games, setGames] = useState([]);
    const [recievedGames, setReceivedGames] = useState(false)

    useEffect(() => {
        API.get("games/get-all-games").then(response => {
            setGames(response.data);
            setReceivedGames(true);
        }).catch(error => {
            console.log(error)
        })
    }, []);

    return (
        <div className="bg-gradient-dark text-white">
            <Container data-bs-theme="dark">
                <Row className={"m-5 pt-5 d-flex justify-content-center"}>
                    {!recievedGames &&
                        <div className="spinner-border" role="status">
                        </div>
                    }
                    {games.map((game, i) => (
                        <Col key={i}>
                            <Link to={`/games/` + game.name}
                                  className="text-decoration-none d-flex justify-content-center">
                                <Card style={{width: '18rem'}} className=" h-100">
                                    <iframe className="p-2 pb-0" src={game.video_link}
                                            title="YouTube video player"
                                            frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope;
                            picture-in-picture; web-share" referrerPolicy="strict-origin-when-cross-origin"
                                            allowFullScreen></iframe>
                                    <Card.Body>
                                        <Card.Title>{game.name}</Card.Title>
                                        <Card.Text>
                                            {game.short_description}
                                        </Card.Text>
                                    </Card.Body>
                                </Card>
                            </Link>
                        </Col>
                    ))}
                </Row>
            </Container>

        </div>
    );
}

export default Games;